import React, { Component } from "react";
import SalesFilterTag from "./SalesFilterTag";
import {
	decDaysToDate,
	formatDateToComputerDate,
	formatDateToLocalDate
} from "../../../../shared/utils";
import { bindActionCreators } from "redux";
import { getAllSales, handleChangeFilterStatements, handleSearch } from "../../../../actions/sales";
import connect from "react-redux/es/connect/connect";
import Button from "../../../../../shared/button/button";

class SalesFilterListTags extends Component {
	constructor(props) {
		super(props);
		this.state = {};

		this.startDefaultDate = formatDateToComputerDate(decDaysToDate(new Date(), 365));
		this.endDefaultDate = formatDateToComputerDate(new Date());
	}

	handleTagsIfNeed = () =>
		this.props.filteredStatements.start !== this.startDefaultDate ||
		this.props.filteredStatements.end !== this.endDefaultDate ||
		this.props.filteredStatements.idsFidelity.length > 0;

	handleChangeFilterStatements = newStatement => {
		this.props.handleChangeFilterStatements(this.props.filteredStatements, newStatement, true);
	};

	handleResetSearch = () => {
		this.props.getAllSales(this.props.filteredStatements);
	};

	renderFilteredFidelityPlans = () => {
		const { idsFidelity } = this.props.filteredStatements;
		return this.props.fidelityPlans.map(fidelityPlan => {
			return idsFidelity.map(ids => {
				if (ids === fidelityPlan.idFidelity) {
					return (
						<SalesFilterTag
							key={fidelityPlan.idFidelity}
							value={fidelityPlan.nameFidelity}
							handleButtonClose={() => this.removeFidelityPlanFromFilter(fidelityPlan.idFidelity)}
							hiddenButtonClose={this.props.isFetching}
						/>
					);
				}
			});
		});
	};

	removeFidelityPlanFromFilter = fidelityPlanId => {
		const { idsFidelity } = this.props.filteredStatements;
		idsFidelity.splice(idsFidelity.indexOf(fidelityPlanId), 1);
		this.handleChangeFilterStatements({ idsFidelity });
	};

	filterrenderIncOrDecScrollButtons = () => {
		let carousel = document.getElementById("sales-filter-list-tags--carousel");

		if (carousel) {
			this.setState({
				showDecScrollButton: carousel.scrollLeft > 0,
				showIncScrollButton:
					carousel.scrollWidth > carousel.clientWidth &&
					carousel.scrollLeft + carousel.clientWidth < carousel.scrollWidth
			});
		}
	};

	incScroll = () => {
		document.getElementById("sales-filter-list-tags--carousel").scrollBy(100, 0);
		this.filterrenderIncOrDecScrollButtons();
	};

	decScroll = () => {
		document.getElementById("sales-filter-list-tags--carousel").scrollBy(-100, 0);
		this.filterrenderIncOrDecScrollButtons();
	};

	componentWillReceiveProps(prev, next) {
		this.filterrenderIncOrDecScrollButtons();
	}

	componentDidMount() {
		this.filterrenderIncOrDecScrollButtons();
	}

	render() {
		const { filteredStatements, isFetching, searched } = this.props;

		if (this.handleTagsIfNeed()) {
			return (
				<div
					className={`sales-filter-list-tags${
						isFetching ? " sales-filter-list-tags--disabled" : ""
					}`}
				>
					{/*
                        Retornar o scroll
                    */}
					<Button
						onClick={this.decScroll}
						className={`btn-gray-md-icon sales-filter-list-tags--button-scroll-dec`}
						data-action="sales-filter-list-tags-scroll-dec"
					>
						{this.state.showDecScrollButton && <i className="icon-arrow-down" />}
					</Button>

					<div
						id="sales-filter-list-tags--carousel"
						className={`sales-filter-list-tags__container-tags${
							!this.state.showDecScrollButton ? " sales-filter-list-tags--hasnt-dec-button" : ""
						}${!this.state.showIncScrollButton ? " sales-filter-list-tags--hasnt-inc-button" : ""}`}
						onScroll={this.filterrenderIncOrDecScrollButtons}
					>
						{/*
                            Renderiza as datas caso sejam diferentes do intervalo padrao
                        */}
						{(filteredStatements.start !== this.startDefaultDate ||
							filteredStatements.end !== this.endDefaultDate) && (
							<SalesFilterTag
								value={`${formatDateToLocalDate(
									filteredStatements.start
								)} - ${formatDateToLocalDate(filteredStatements.end)}`}
								handleButtonClose={() =>
									this.handleChangeFilterStatements({
										start: this.startDefaultDate,
										end: this.endDefaultDate
									})
								}
							/>
						)}

						{/*
                            Renderiza os planos de fidelidade selecionados
                        */}
						{filteredStatements.idsFidelity.length > 0 && this.renderFilteredFidelityPlans()}
					</div>

					{/*
                    Avancar o scroll
                */}
					<Button
						onClick={this.incScroll}
						className="btn-gray-md-icon sales-filter-list-tags--button-scroll-inc"
						data-action="sales-filter-list-tags-scroll-inc"
					>
						{this.state.showIncScrollButton && <i className="icon-arrow-down" />}
					</Button>
				</div>
			);
		}

		if (this.props.searched && this.props.searched.length > 0) {
			return (
				<div
					className={`sales-filter-list-tags${
						isFetching ? " sales-filter-list-tags--disabled" : ""
					}`}
				>
					<div
						id="sales-filter-list-tags--carousel"
						className={`sales-filter-list-tags__container-tags${
							!this.state.showDecScrollButton ? " sales-filter-list-tags--hasnt-dec-button" : ""
						}${!this.state.showIncScrollButton ? " sales-filter-list-tags--hasnt-inc-button" : ""}`}
						onScroll={this.filterrenderIncOrDecScrollButtons}
					>
						{/*
                            Recuar o scroll
                        */}
						<Button
							onClick={this.decScroll}
							className={`btn-gray-md-icon sales-filter-list-tags--button-scroll-dec`}
							data-action="sales-filter-list-tags-scroll-dec"
							disable
						>
							{this.state.showDecScrollButton && <i className="icon-arrow-down" />}
						</Button>
						<SalesFilterTag value={searched} handleButtonClose={() => this.handleResetSearch()} />
						{/*
                            Avancar o scroll
                        */}
						<Button
							onClick={this.incScroll}
							className="btn-gray-md-icon sales-filter-list-tags--button-scroll-inc"
							data-action="sales-filter-list-tags-scroll-inc"
							disable
						>
							{this.state.showIncScrollButton && <i className="icon-arrow-down" />}
						</Button>
					</div>
				</div>
			);
		}

		return false;
	}
}

const mapStateToProps = state => ({
	filteredStatements: state.mySales.filteredStatements,
	isFetching: state.mySales.isFetching,
	searched: state.mySales.searched,
	fidelityPlans: state.util.fidelityPlansFromUserSales
});

const mapDispatchToProps = dispacth =>
	bindActionCreators(
		{
			handleChangeFilterStatements,
			handleSearch,
			getAllSales
		},
		dispacth
	);
export default connect(mapStateToProps, mapDispatchToProps)(SalesFilterListTags);
